<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M4 9V16C4 17.6569 5.34315 19 7 19H15.1707C15.5825 20.1652 16.6938 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.6938 15 15.5825 15.8348 15.1707 17H7C6.44772 17 6 16.5523 6 16V11.8293C6.31278 11.9398 6.64936 12 7 12H15.1707C15.5825 13.1652 16.6938 14 18 14C19.6569 14 21 12.6569 21 11C21 9.34315 19.6569 8 18 8C16.6938 8 15.5825 8.83481 15.1707 10H7C6.44772 10 6 9.55228 6 9V4H4V9ZM18 10C17.4477 10 17 10.4477 17 11C17 11.5523 17.4477 12 18 12C18.5523 12 19 11.5523 19 11C19 10.4477 18.5523 10 18 10ZM17 18C17 17.4477 17.4477 17 18 17C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
